import React from 'react';

export default function ZipFileIcon() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.73895 3.7072C7.78814 4.1021 7.66539 4.49911 7.40188 4.79733C7.12734 5.0955 6.74053 5.26515 6.33522 5.26515C5.9299 5.26515 5.54309 5.0955 5.26855 4.79733C5.00505 4.49911 4.88229 4.1021 4.93149 3.7072L5.26713 1H7.40046L7.73895 3.7072Z"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33332 7.3999C6.48059 7.3999 6.59998 7.51929 6.59998 7.66657C6.59998 7.81384 6.48059 7.93324 6.33332 7.93324C6.18604 7.93324 6.06665 7.81384 6.06665 7.66657C6.06665 7.51929 6.18604 7.3999 6.33332 7.3999"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33332 10.6001C6.48059 10.6001 6.59998 10.7195 6.59998 10.8668C6.59998 11.014 6.48059 11.1334 6.33332 11.1334C6.18604 11.1334 6.06665 11.014 6.06665 10.8668C6.06665 10.7195 6.18604 10.6001 6.33332 10.6001"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33332 13.7998C6.48059 13.7998 6.59998 13.9192 6.59998 14.0665C6.59998 14.2137 6.48059 14.3331 6.33332 14.3331C6.18604 14.3331 6.06665 14.2137 6.06665 14.0665C6.06665 13.9192 6.18604 13.7998 6.33332 13.7998"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8 17H2.06667C1.47756 17 1 16.5224 1 15.9333V2.06667C1 1.47756 1.47756 1 2.06667 1H11.7584C12.0411 1.00006 12.3122 1.11234 12.5122 1.31218L14.5545 3.35449C14.7543 3.55445 14.8666 3.82557 14.8667 4.10827V15.9333C14.8667 16.5224 14.3891 17 13.8 17Z"
        stroke="#949499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
